export const regionsKeys = {
  regionsList: () => ['regionsList'] as const,
}
